import i18next from "i18next";
import config from '../config';

export const getItsmeLoginUrl = (sp: string, acs: string): string =>
    `${config.PI2_URL_WITH_ITSME}${config.BASE_URL}/redirect-from-itsme/login?params=pi2.sp=${sp}pi2.acs=${acs}`;

export const linkAccountUrl = `${config.PI2_URL}${config.BASE_URL}/redirect-from-itsme/onboarding`;
export const itsMeUrl = `${config.ITSME_URL}/${i18next.language}`;
export const portimaUrl = `https://www.portima.com/${i18next.language}`;
export const portimaPrivacyUrl = `https://www.portima.com/${i18next.language}/privacy`;
export const portimaDisclaimerUrl = `https://www.portima.com/${i18next.language}/disclaimer`;
export const portimaCookiesPolicyUrl = `https://www.portima.com/${i18next.language}/cookie-policy`;
